(() => {
  if (window.monolithDesktopMenuReady) return;
  window.monolithDesktopMenuReady = true;
  const selector = '[data-mnd-nav] .mnd-dropdown';
  const close = (details, focus = false) => {
    details.open = false;
    if (focus) details.querySelector('summary').focus();
  };
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof Element) || !details.matches(selector) || !details.open) return;
    document.querySelectorAll(selector).forEach(other => { if (other !== details) close(other); });
    const panel = details.querySelector('.mnd-panel');
    panel.style.setProperty('--mnd-panel-top', Math.max(0, panel.getBoundingClientRect().top) + 'px');
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-mnd-close]');
    if (button) close(button.closest('.mnd-dropdown'), true);
    document.querySelectorAll(selector).forEach(details => {
      if (details.open && !details.contains(event.target)) close(details);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(selector).forEach(details => {
      if (details.open) { close(details, true); event.preventDefault(); }
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(selector).forEach(details => {
      if (details.open && !details.closest('[data-mnd-nav]').contains(event.target)) close(details);
    });
  });
  window.matchMedia('(min-width:1024px)').addEventListener('change', event => {
    if (!event.matches) document.querySelectorAll(selector).forEach(details => close(details));
  });
})();
